/*
 * ConnectionManager Messages
 *
 * This contains all the text for the ConnectionManager.
 */
import { defineMessages } from 'react-intl';

const scope = 'connection';

export default defineMessages({
  defaultError: {
    id: `${scope}.error.default`,
    defaultMessage: 'An unknown error occurred',
  },
  credentialsError: {
    id: `${scope}.error.credentials`,
    defaultMessage: 'Invalid email or password',
  },
  connectionError: {
    id: `${scope}.error.connection`,
    defaultMessage: 'Couldn\'t connect to the server',
  },
  connectionDownError: {
    id: `${scope}.error.connectionDown`,
    defaultMessage: 'Request failed',
  },
  failedWorkspacePluginListFetch: {
    id: `${scope}.error.failedWorkspacePluginListFetch`,
    defaultMessage: 'There was an error loading the list of plugins',
  },
  failedAuthorPluginListFetch: {
    id: `${scope}.error.failedAuthorPluginListFetch`,
    defaultMessage: 'There was an error loading the list of plugins',
  },
  failedWorkspacePluginCreate: {
    id: `${scope}.error.failedWorkspacePluginCreate`,
    defaultMessage: 'There was an error creating the plugin',
  },
  failedSubscriptionAccountListFetch: {
    id: `${scope}.error.failedSubscriptionAccountListFetch`,
    defaultMessage: 'There was an error loading the account list for the subscription',
  },
  failedSubscriptionTeamListFetch: {
    id: `${scope}.error.failedSubscriptionTeamListFetch`,
    defaultMessage: 'There was an error loading the team list for the subscription',
  },
  failedWorkspacePluginDetailsFetch: {
    id: `${scope}.error.failedWorkspacePluginDetailsFetch`,
    defaultMessage: 'There was an error loading the plugin details',
  },
  failedWorkspacePluginUpdate: {
    id: `${scope}.error.failedWorkspacePluginUpdate`,
    defaultMessage: 'There was an error updating plugin summary',
  },
  failedWorkspacePluginAccountListFetch: {
    id: `${scope}.error.failedWorkspacePluginAccountListFetch`,
    defaultMessage: 'There was an error loading the accounts list for plugin',
  },
  permissionGrantError: {
    id: `${scope}.error.permissionGrantError`,
    defaultMessage: 'There was an error granting permission',
  },
  permissionRevokeError: {
    id: `${scope}.error.permissionRevokeError`,
    defaultMessage: 'There was an error revoking permission',
  },
  failedWorkspaceCohortListFetch: {
    id: `${scope}.error.failedWorkspaceCohortListFetch`,
    defaultMessage: 'There was an error loading the list of classes',
  },
  failedWorkspaceCohortFetch: {
    id: `${scope}.error.failedWorkspaceCohortFetch`,
    defaultMessage: 'There was an error loading the class',
  },
  failedWorkspaceCohortCreate: {
    id: `${scope}.error.failedWorkspaceCohortCreate`,
    defaultMessage: 'There was an error creating the class',
  },
  failedWorkspaceCohortAccountSummaryFetch: {
    id: `${scope}.error.failedWorkspaceCohortAccountSummaryFetch`,
    defaultMessage: 'There was an error loading the class account summary',
  },
  failedWorkspaceActivityListFetch: {
    id: `${scope}.error.failedWorkspaceActivityListFetch`,
    defaultMessage: 'There was an error loading the list of courses',
  },
  failedWorkspaceCohortInstructorsListFetch: {
    id: `${scope}.error.failedWorkspaceCohortInstructorsListFetch`,
    defaultMessage: 'There was an error loading the instructors list for class',
  },
  failedWorkspaceCohortEnrollmentsListFetch: {
    id: `${scope}.error.failedWorkspaceCohortEnrollmentsListFetch`,
    defaultMessage: 'There was an error loading the enrollments list for class',
  },
  failedWorkspaceDeploymentsListFetch: {
    id: `${scope}.error.failedWorkspaceDeploymentsListFetch`,
    defaultMessage: 'There was an error loading deployments list for class',
  },
  cohortArchiveError: {
    id: `${scope}.error.failedWorkspaceCohortArchive`,
    defaultMessage: 'There was an error deleting a class',
  },
  failedWorkspaceCohortUpdate: {
    id: `${scope}.error.failedWorkspaceCohortUpdate`,
    defaultMessage: 'There was an error updating the class',
  },
  failedWorkspaceAccountCreate: {
    id: `${scope}.error.failedWorkspaceAccountCreate`,
    defaultMessage: 'There was an error creating account',
  },
  failedWorkspaceAccountsList: {
    id: `${scope}.error.failedWorkspaceAccountsList`,
    defaultMessage: 'There was an error loading list of accounts',
  },
  failedIamTeamCreate: {
    id: `${scope}.error.failedIamTeamCreate`,
    defaultMessage: 'There was an error creating the team',
  },
  failedWorkspaceTeamList: {
    id: `${scope}.error.failedWorkspaceTeamList`,
    defaultMessage: 'There was an error loading the list of teams',
  },
  failedWorkspaceWorkspacesList: {
    id: `${scope}.error.failedWorkspaceWorkspacesList`,
    defaultMessage: 'There was an error loading the workspaces list',
  },
  failedWorkspaceCollaboratorsSummary: {
    id: `${scope}.error.failedWorkspaceCollaboratorsSummary`,
    defaultMessage: 'There was an error loading the workspace collaborators summary',
  },
  failedIamTeamAccountSummaryFetch: {
    id: `${scope}.error.failedIamTeamAccountSummaryFetch`,
    defaultMessage: 'There was an error loading the account list for team',
  },
  failedWorkspaceCohortAccountEnroll: {
    id: `${scope}.error.failedWorkspaceCohortAccountEnroll`,
    defaultMessage: 'There was an error enrolling the account',
  },
  failedWorkspaceActivityPublish: {
    id: `${scope}.error.failedWorkspaceActivityPublish`,
    defaultMessage: 'There was an error publishing the activity',
  },
  failedProjectActivityPublish: {
    id: `${scope}.error.failedProjectActivityPublish`,
    defaultMessage: 'There was an error publishing the activity',
  },
  failedWorkspaceCoursewareMetaInfoGet: {
    id: `${scope}.error.failedWorkspaceCoursewareMetaInfoGet`,
    defaultMessage: 'There was an error getting the courseware meta info with key: {key}',
  },
  failedWorkspaceCoursewareMetaInfoSet: {
    id: `${scope}.error.failedWorkspaceCoursewareMetaInfoSet`,
    defaultMessage: 'There was an error setting the courseware meta info with key: {key}',
  },
  failedWorkspacePluginDeleteError: {
    id: `${scope}.error.failedWorkspacePluginDeleteError`,
    defaultMessage: 'There was an error deleting the plugin',
  },
  failedWorkspaceProjectList: {
    id: `${scope}.error.failedWorkspaceProjectList`,
    defaultMessage: 'There was an error loading the list of projects',
  },
  failedWorkspaceProjectIngestList: {
    id: `${scope}.error.failedWorkspaceProjectIngestList`,
    defaultMessage: 'There was an error loading the list of ingestions',
  },
  failedWorkspacePublicationsList: {
    id: `${scope}.error.failedWorkspacePublicationsList`,
    defaultMessage: 'There was an error loading the list of publications',
  },
  failedWorkspaceProjectCreate: {
    id: `${scope}.error.failedWorkspaceProjectCreate`,
    defaultMessage: 'There was an error creating the project',
  },
  failedAuthorPluginVersionDelete: {
    id: `${scope}.error.failedAuthorPluginVersionDelete`,
    defaultMessage: 'There was an error deleting the plugin version',
  },
  failedAuthorPluginVersionUnpublish: {
    id: `${scope}.error.failedAuthorPluginVersionUnpublish`,
    defaultMessage: 'There was an error unpublishing the plugin version',
  },
});
